import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';
import { features } from './data';
import BG from "src/assets/images/home/features/bg.webp";

export default function Features() {
    const { t, i18n } = useTranslation("home");
    const currentLang = i18n.language as 'ar' | 'en' | 'it';

    return (
        <section className={[styles.features__section, currentLang.includes("ar") ? styles.is_rtl : null].join(" ")} style={{ backgroundImage: `url(${BG})` }}>
            <div className="container">
                <div className={styles.titleCon}>
                    <div className={styles.subTitle}>
                        {t("features.sub_title")}
                    </div>
                    <h2 className={styles.title}>
                        {t("features.title")}
                    </h2>
                </div>

                <div className="row">
                    {features.map((item, index) => (
                        <div
                            key={`feature-key-${index}`}
                            className="col-lg-4 col-md-6 col-12 mx-auto"
                            data-aos="fade-up"
                            data-aos-delay={index * 80} // delay each card by 150ms
                        >
                            <div className={styles.card}>
                                <img src={item.img} alt={item.title[currentLang]} />
                                <h4>{item.title[currentLang]}</h4>
                                <p>{item.content[currentLang]}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
